// extracted by mini-css-extract-plugin
module.exports =  {"active":"qqw2fufTqvKbJTrgjnvK","content":"VF82F94FBCqAhUaDaTIy","tabs":"KKPJtoKfUa3UHoE2YaZx"};